// extracted by mini-css-extract-plugin
export default {"scheduleLink":"list_scheduleLink__5jIAL"};